"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgMoreTime = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 21", fill: "currentColor", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { d: "M9 20.5q-1.874 0-3.512-.7a9 9 0 0 1-2.863-1.925A9 9 0 0 1 .7 15.012 8.8 8.8 0 0 1 0 11.5q0-3.775 2.613-6.388T9 2.5a7.5 7.5 0 0 1 1.225.1q.325.05.55.337t.225.638q0 .5-.337.762-.338.263-.863.213A7 7 0 0 0 9 4.5q-2.95 0-4.975 2.025T2 11.5t2.025 4.975T9 18.5q2.925 0 4.938-2T16 11.575q0-.425.288-.75A.91.91 0 0 1 17 10.5q.4 0 .7.287.3.288.3.663v.05q0 3.776-2.613 6.387Q12.776 20.5 9 20.5m8-12a.97.97 0 0 1-.712-.288A.97.97 0 0 1 16 7.5v-2h-2a.97.97 0 0 1-.712-.287A.97.97 0 0 1 13 4.5q0-.425.288-.713A.97.97 0 0 1 14 3.5h2v-2q0-.425.288-.713A.97.97 0 0 1 17 .5q.424 0 .712.287.288.288.288.713v2h2q.424 0 .712.287.288.288.288.713a.97.97 0 0 1-.288.713A.97.97 0 0 1 20 5.5h-2v2q0 .424-.288.712A.97.97 0 0 1 17 8.5M11.1 15l-2.8-2.8a1.03 1.03 0 0 1-.3-.725V7.5q0-.425.288-.713A.97.97 0 0 1 9 6.5a.97.97 0 0 1 .713.287A.97.97 0 0 1 10 7.5v3.6l2.5 2.5a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275" })));
const ForwardRef = (0, react_1.forwardRef)(SvgMoreTime);
exports.default = ForwardRef;
